<template>
  <div
    class="tabview"
    @click="$emit('selected', type)"
    :style="selected ? 'border-bottom: 3px solid #188dff' : ''"
  >
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: 'TankingTabView',
  props: {
    type: Number,
    title: String,
    selected: Boolean,
  },
}
</script>

<style scoped>
.tabview {
  line-height: 42px;
  display: inline-block;
  width: 50%;
  height: 42px;
  font-size: 14px;
  color: #000;
  text-align: center;
  flex-grow: 1;
}
.tabview p {
  font-family: Hiragino Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 42px;

  align-items: center;
  text-align: center;
}
</style>
